import { render, staticRenderFns } from "./statCampaign.vue?vue&type=template&id=6aea0d56&"
import script from "./statCampaign.vue?vue&type=script&lang=js&"
export * from "./statCampaign.vue?vue&type=script&lang=js&"
import style0 from "./statCampaign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports